import { touchWebClient } from 'tradera/utils/http';

export const getProfile = async (memberId) =>
    touchWebClient.get(`/profile/api/${memberId}`);

export const followSeller = async (sellerId) =>
    touchWebClient.post(`/my/favourite-sellers/add`, { sellerId });

export const unfollowSeller = async (sellerId) =>
    touchWebClient.post(`/my/favourite-sellers/remove`, { ids: [sellerId] });

export const getShopDetails = async (memberId) =>
    touchWebClient.get(`profile/api/${memberId}/shopdetails`);
